<script>
  export let imageSrc = "";
  export let title = "";
  export let description = "";
  export let alt = "Service Card";
</script>

<div
  class="
    w-[280px]
    overflow-hidden
    rounded-xl
    bg-blue-50 /* light tinted background */
    shadow-md /* soft elevation */
    text-center
  "
>
  <div class="px-3 pt-4 pb-5">
    {#if title}
      <h3 class="text-3xl font-bold text-gray-900 leading-tight">
        {title}
      </h3>
    {/if}
  </div>

  {#if imageSrc}
    <img
      src={imageSrc}
      {alt}
      class="w-[280px] h-[190px] object-fill rounded-xl"
      width="280"
      height="190"
      loading="lazy"
    />
  {/if}

  <div class="px-3 pt-4 pb-5">
    {#if description}
      <p class="mt-2 text-md text-gray-900 leading-snug">
        {description}
      </p>
    {/if}
  </div>
</div>
